import React from 'react';
import { SmartTagsTextAreaLayoutProps } from 'ui-builder';
import useFeatureToggleService from 'feature-toggle';
import BaseTagsInputLayout from './BaseTagsInputLayout';

export default function SmartTagsTextAreaLayout(props: SmartTagsTextAreaLayoutProps) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  return (
    <BaseTagsInputLayout {...props} isMultiLine useShadcnLayout={isShadcnUiEnabled()} />
  );
}
